// Gerador simples de IDs únicos (sem dependências externas).
// Pode ser substituído por uuid() de uma lib real quando integrado a um backend.
export function generateId(prefix = "id") {
  const random = Math.random().toString(36).slice(2, 10);
  const time = Date.now().toString(36);
  return `${prefix}_${time}_${random}`;
}
